import React from 'react';
import Navbar from '../../components/Navbar';

function PrivacyPolicy() {
    return (
        <div>
            <Navbar />
            <main className="container" style={{ padding: 'var(--spacing-xl) 0', maxWidth: '760px' }}>
                <h1 style={{ marginBottom: '0.5rem' }}>Privacy Policy</h1>
                <p className="text-muted" style={{ marginBottom: '2rem' }}>Last updated: January 2025</p>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>1. Information We Collect</h2>
                    <p>We collect information you provide when registering, enrolling in courses, or interacting with the platform — including your name, email address, phone number, and date of birth. We also collect usage data to improve the platform experience.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>2. How We Use Your Information</h2>
                    <p>Your information is used to manage your account, enroll you in courses, track your learning progress, communicate platform updates, and improve our services. We do not sell your personal information to third parties.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>3. Data Security</h2>
                    <p>We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, disclosure, alteration, or destruction. All data is transmitted over HTTPS.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>4. Cookies</h2>
                    <p>We use session tokens stored in your browser's local storage to maintain your authenticated session. We do not use third-party tracking cookies.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>5. Your Rights</h2>
                    <p>You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us at <a href="mailto:privacy@learnly.co.za">privacy@learnly.co.za</a>.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>6. Changes to This Policy</h2>
                    <p>We may update this Privacy Policy from time to time. We will notify you of significant changes via email or through the platform.</p>
                </section>
            </main>
        </div>
    );
}

export default PrivacyPolicy;
